var Honeybadger = require("@honeybadger-io/js");

Honeybadger.configure({
  apiKey: process.env.HONEYBADGER_API_KEY,
  environment: process.env.RAILS_ENV || process.env.NODE_ENV,
  revision: process.env.HEROKU_SLUG_COMMIT
});

window.HoneyBadger = {
  report: function (payload) {
    if (payload instanceof Error) {
      Honeybadger.notify(payload);
      return;
    }

    var err = payload && payload.err;
    var context = {};
    Object.keys(payload || {}).forEach(function (key) {
      if (key !== "err") context[key] = payload[key];
    });

    Honeybadger.notify(err || "Manual HoneyBadger.report", { context: context });
  },
};

module.exports = window.HoneyBadger;
